/* Returns a window of the given items array */
export function getRangeCenteredAt<T>(centerIdx: number, size: number, items: T[]): T[] {
    var flanking = Math.floor(size / 2);

    if (centerIdx - flanking <= 0) {
        return items.slice(0, size);
    }

    if (centerIdx + flanking > items.length - 1) {
        const sliceIdx = Math.max(0, items.length - size);
        return items.slice(sliceIdx);
    }

    return items.slice(centerIdx - flanking, centerIdx + flanking);
}



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./App/global/functions/math.ts